export default __webpack_public_path__ + "static/media/IncomingOrderSound.16058227.wav";